import type { GenericObject } from '@makemydeal/dr-platform-types';

export const buildContractingQueryString = (query?: GenericObject): string => {
    return Object.entries(query || {})
        .filter(([, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
};
